import axios from "axios";

const userService = axios.create({
    baseURL: process.env.VUE_APP_USER + "/user",
    timeout: 30000,
    withCredentials: true
});
userService.defaults.headers['Product'] = 'vsp';

userService.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

userService.interceptors.response.use(
    response => {
        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    /**
     *
     * @param {
     * sessionId
     *  loginName
     * loginType
     * productName
     * password
     * verifyCode
     * } params
     *
     */

    CheckUserExist(loginName) {
        return userService.post(`/check/user/exist/${loginName}`);
    },

    RegisterUser(param) {
        return userService.post("/register", param);
    },

    UpdateUserInfo(param) {
        return userService.post("/update/user", param);
    },

    AttachInfo() {
        return userService.post("/user/attachInfo");
    },
    UpdatePortraitUrl(param) {
        return userService.post("/update/portraitUrl", param);
    },
    UpdatePhone(param) {
        return userService.post("/update/phone", param);
    },
    UpdateEmail(param) {
        return userService.post("/update/email", param);
    },
    UpdateEmail(param) {
        return userService.post("/update/email", param);
    },
    UpdatePassword(param) {
        return userService.post("/update/password", param);
    },
    CheckBindMobile() {
        return userService.post("/check/bind/phone");
    },
    CheckPhoneUser(param) {
        return userService.post("/checkPhoneUser", param);
    },
    UpdatePassword(param) {
        return userService.post("/update/password", param);
    },
    ResetPassword(param) {
        return userService.post("/reset/password", param);
    },
    CheckPhoneUserExist(phoneNO) {
        return userService.post(`/check/phone/${phoneNO}`);
    },
    // 获取当前用户的额外信息
    getUserInfoOptions() {
        return userService.post(`/getUserInfoOptions`);
    },
    // 更新用户额外信息
    updateUserInfoOptions(param) {
        return userService.post(`/updateUserInfoOptions`, param);
    },
    checkUserAttachInfo() {
        return userService.post(`/checkUserAttachInfo`);
    },
    userList(params) {
        return userService.post(`/search`, params);
    },
};